import { ProfileData } from 'interfaces/authentication';

export const userActiveStep = {
  USER_ACTIVE_STEP_STATE_VALUE_0: 0, // Data Processing
  USER_ACTIVE_STEP_STATE_VALUE_5: 5, // Waiting Client
  USER_ACTIVE_STEP_STATE_VALUE_3: 3, // KYC Failed
  USER_ACTIVE_STEP_STATE_VALUE_4: 4, // KYC Expired
  USER_ACTIVE_STEP_STATE_VALUE_7: 7, //  Waiting for Provider
  USER_ACTIVE_STEP_VALUE_21: 21,
  USER_ACTIVE_STEP_VALUE_27: 27,
  USER_ACTIVE_STEP_VALUE_33: 33,
  USER_ACTIVE_STEP_VALUE_35: 35,
  USER_ACTIVE_STEP_VALUE_37: 37,
  USER_ACTIVE_STEP_VALUE_40: 40, // Signicat Germany
  USER_ACTIVE_STEP_VALUE_41: 41, // Signicat Brazil
  USER_ACTIVE_STEP_VALUE_42: 42, // Legitimuz Brazil
  USER_ACTIVE_STEP_VALUE_43: 43,
  USER_ACTIVE_STEP_VALUE_50: 50
};

export const CLIENT_PRODUCT_STATE_CATEGORIES = {
  sport: 1,
  casino: 2
};

export const checkUserStatus = {
  bankIdIntergration(user: ProfileData | Record<string, any>): boolean {
    return (
      user.active_step === userActiveStep.USER_ACTIVE_STEP_VALUE_35 &&
      user.active_step_state === userActiveStep.USER_ACTIVE_STEP_STATE_VALUE_5
    );
  }
};
